
import BuyerLandingHeader from "@/components/buyer/landing/BuyerLandingHeader";
import BuyerLandingHero from "@/components/buyer/landing/BuyerLandingHero";
import BuyerLandingFeatures from "@/components/buyer/landing/BuyerLandingFeatures";
import BuyerLandingHowItWorks from "@/components/buyer/landing/BuyerLandingHowItWorks";
import BuyerLandingPricing from "@/components/buyer/landing/BuyerLandingPricing";
import BuyerLandingCTA from "@/components/buyer/landing/BuyerLandingCTA";
import TrustpilotSection from "@/pages/marketing/components/TrustpilotSection";
import SellerSection from "@/components/buyer/landing/SellerSection";
import BuyerLandingFooter from "@/components/buyer/landing/BuyerLandingFooter";
import PageSEO from "@/components/seo/PageSEO";
import StructuredData from "@/components/seo/StructuredData";

const BuyerLandingPage = () => {
  return (
    <div className="min-h-screen bg-[#080c14] text-white">
      <PageSEO
        title="Find Wholesale Real Estate Deals | Off-Market Properties | GoDyspo"
        description="Discover high-quality off-market investment properties and wholesale deals. Search fix & flip, BRRRR, and distressed properties. Connect directly with wholesalers. Start free today."
        canonical="/buyer"
        keywords="wholesale real estate deals, off-market properties, investment properties, fix and flip properties, BRRRR properties, distressed properties, cash buyer deals, wholesale contracts, real estate investment deals"
      />
      <StructuredData 
        type="BreadcrumbList" 
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "For Investors", url: "/buyer" }
        ]} 
      />
      <BuyerLandingHeader />
      <div className="max-w-screen-2xl mx-auto">
        <BuyerLandingHero />
        <BuyerLandingFeatures />
        <BuyerLandingHowItWorks />
        <BuyerLandingPricing />
        <BuyerLandingCTA />
        <TrustpilotSection />
        <SellerSection />
      </div>
      <BuyerLandingFooter />
    </div>
  );
};

export default BuyerLandingPage;
